export default ({
  namespaced: true,

  state: {
    dependents: 0,
    formSubmitted: false,
    validatedForms: 0,
    totalForms: 2
  },
  
  getters: {
    dependents: state => state.dependents,
    formSubmitted: state => state.formSubmitted,
    validatedForms: state => state.validatedForms,
    totalForms: state => {
      return state.totalForms + state.dependents
    }
  },

  mutations: {
    setDependents(state, value) {
      if (value)
        state.dependents++
      else
        state.dependents--
    },
    setFormSubmitted(state, value) {
      if (value)
        state.formSubmitted = true
      else
        state.formSubmitted = false
    },
    resetFormSubmitted(state) {
      state.formSubmitted = false
      // state.validatedForms = 0
    },
    clearStoreData(state) {
      state.formSubmitted = false
      state.validatedForms = 0
    },
    setValidatedForms(state, value) {
      if (value)
        state.validatedForms++
      // else
      //   state.validatedForms--
    }
  },

  actions: {
    //
  }
})